import { UIContent } from "../../../UIContent";

/**
 * Returns all PlatformBuilder modules that should appear
 * in the Access Control Builder UI (so admins can configure who can access what).
 */
export const getAccessControlEnabledPLBModules = () =>
  [...menuOps, ...oldMenuOps]
    .reduce((a, b) => [...a, ...(b.subMenu || [b])], [])
    .filter((d) => d.makeControllableViaAccessControlBuilder === true);

/**
 * Menu config for PlatformBuilder sidebar.
 *
 * KEY FLAGS (per menu item):
 *
 * makeControllableViaAccessControlBuilder (bool)
 *   → If true, this module will appear in the Access Control Builder UI,
 *     allowing admins to configure role-based permissions for it.
 *
 * ACLFunctionToUse ('moduleACL' | 'platformBuilderACL')
 *   → Determines which ACL system is used to check user access at runtime:
 *     - 'moduleACL'            → uses __CheckSomeAccessToSomeModule (checks _Roles[role].modules)
 *     - 'platformBuilderACL'   → uses __CheckSomeAccessToSomePlatformBuilderModule (checks _Roles[role].platformBuilder)
 *     - If omitted (and makeControllableViaAccessControlBuilder is true), defaults to 'platformBuilderACL'.
 *     - If makeControllableViaAccessControlBuilder is false/absent, falls back to superAdmin-only check.
 */
export const menuOps = [
  {
    display: "General",
    comp: "General",
    value: "general",
    icon: "Cube",
  },
  {
    display: UIContent.UserSettings.title,
    comp: "UserSettings",
    value: "usersManager",
    icon: "UserList",
    infoTooltip: {
      text: UIContent.UserSettings.infoTooltip,
      position: "bottom",
    },
    makeControllableViaAccessControlBuilder: true,
    ACLFunctionToUse: 'moduleACL',
    addToGeneral: true,
  },
  {
    display: "Content Templates",
    comp: "ContentTypesManager",
    value: "contentTypesManager",
    icon: "Table",
    makeControllableViaAccessControlBuilder: true,
    addToGeneral: true,
  },
  {
    display: "Tags Manager",
    value: "tagsManager",
    comp: "TagsManager",
    icon: 'Tag',
    addToGeneral: true,
    makeControllableViaAccessControlBuilder: true
  },
  {
    display: "Tags Manager V2",
    value: "tagsManagerV2",
    comp: "TagsManagerV2",
    icon: 'Tag',
    addToGeneral: true,
    makeControllableViaAccessControlBuilder: true
  },
  {
    display: "System",
    value: "system",
    icon: "Browsers",
    subMenu: [
      {
        display: "Themes Settings",
        value: "themesSettings",
        comp: "ThemesSettings",
        infoTooltip: {
          text: `Themes allow you to set colors for the platform according to your brand guidelines`,
          position: "bottom",
        },
        makeControllableViaAccessControlBuilder: true,
        addToGeneral: true,
      },

      {
        display: "Navigation",
        value: "navigation",
        comp: "GlobalNavBuilder",
        infoTooltip: {text: `In the navigation section, you have 3 sections.
        Logo Section is to upload logos for both header and footer.
        Header Section is to add pages to the header.
        Footer Section is to hide/show links from the header and add any other required links`, position: 'bottom'},
        makeControllableViaAccessControlBuilder: true,
        addToGeneral: true,
        
      },
      {
        display: "Language Settings",
        value: "adminLocaleData",
        comp: "AdminLocaleData",
      },
      {
        display: "Access Control",
        comp: "AccessControlBuilder",
        value: "accessControl",
        infoTooltip: {text:UIContent.AccessControlBuilder.SubModuleHeader_tooltip,position:"bottom"},
        makeControllableViaAccessControlBuilder: true,
        addToGeneral: true,
        
      },
    ],
  },
  {
    display: "Activity Analytics",
    value: "adminActivityAnalyticsList",
    comp: "AdminActivityAnalyticsList",
    icon: "Activity",
    makeControllableViaAccessControlBuilder: true,
    addToGeneral: true,
  },
  {
    display: "User Analytics",
    value: "userAnalytics",
    comp: "UserAnalytics",
    icon: "Activity",
   makeControllableViaAccessControlBuilder: true,
   // addToGeneral: true,
  },
    {
    display: "AI Control Pannel",
    value: "annotationExplorer",
    comp: "AnnoExplorerControlPannel",// todo : the comp should be a general ai control pannel comp
    icon: "File",
     makeControllableViaAccessControlBuilder: true,
  },
  {
    display: "Static Pages",
    value: "staticPages",
    comp: "AdminStaticPagesEdit",
    makeControllableViaAccessControlBuilder: true,
    icon: "File",
  },
  {
    display: "Data Architecture (beta)",
    value: "dataArchitecture",
    comp: "AdminDataArchitectureViz",
    icon: "File",
  },
  {
    display: "Platform Context",
    comp: "PlatformContextEditor",
    value: "platformContext",
    icon: "Info",
  },
  {
    display: "AI Engine Manager",
    comp: "AIEngineManager",
    value: "aiEngineManager",
    makeControllableViaAccessControlBuilder: true,
    ACLFunctionToUse: 'moduleACL',
    icon: "Robot",
  },
  {
    display: "Provision Tenant",
    comp: "ProvisionTenant",
    value: "provisionTenant",
    icon: "Database",
  },
  {
    display: "Reset Tenant",
    comp: "ResetTenant",
    value: "resetTenant",
    icon: "Trash",
  },
  {
    display: "Active Tenants",
    comp: "ActiveTenants",
    value: "activeTenants",
    icon: "Database",
  },
  // NOT PRODUCTION-READY / UNTESTED — kept out of the menu so it's unreachable.
  // See okf-be/routes/api/globalAdminTools/services/deleteTenant/README.md for the
  // pre-production test checklist. Uncomment only after that checklist passes.
  // {
  //   display: "Delete Tenant",
  //   comp: "DeleteTenant",
  //   value: "deleteTenant",
  //   icon: "Trash",
  // },
  {
    display: "API Documentation",
    comp: "APIDocumentation",
    value: "apiDocumentation",
    icon: "File",
    makeControllableViaAccessControlBuilder: true,
  },
  {
    display: "Add-On Modules",
    comp: "SM_AddOnModules",
    value: "addOnModules",
    icon: "Stack",
    makeControllableViaAccessControlBuilder: true,
    ACLFunctionToUse: 'moduleACL',
  },
];

export const oldMenuOps = [
  {
    display: "Global Configurations",
    value: "globals",
    comp: "ConfigGlobals",
    props: { type: "deployment" },
    addToGeneral: true,
  }
];


 

